import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {manualdatasettingsRoutingModule} from './manualdatasettings-routing.module';
import {ManualdatasettingsComponent} from './manualdatasettings.component';
import { DevEpressCommonModule } from 'src/app/dev-epress-common.module';
import {
  DxDataGridModule, DxChartModule, DxBulletModule, DxTemplateModule

} from 'devextreme-angular';



@NgModule({
  declarations: [ManualdatasettingsComponent],
  imports: [
    CommonModule,
    manualdatasettingsRoutingModule,
    DxDataGridModule,
    DxChartModule,
    DevEpressCommonModule,
    DxDataGridModule,
    DxBulletModule,
    DxTemplateModule,
  ]
})
export class ManualdatasettingsModule { }
